import {ReffererLayout} from '@app/analytics/analytics-provider/types'
import GameLink from '@app/components/custom-links/game-link'
import {FC, useRef} from 'react'
import {useInView} from 'react-cool-inview'

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  onVisible: () => void
  gameCode: string
  gameName: string
  propertyCode: string
  reffererLayout?: ReffererLayout
}

const GameLinkWithImpressionTracking: FC<Props> = ({
  onVisible,
  children,
  gameCode,
  gameName,
  propertyCode,
  reffererLayout,
  ...restProps
}) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null)
  const hasTriggeredRef = useRef<boolean>(false)

  const {observe, unobserve} = useInView<HTMLAnchorElement>({
    threshold: 0.55,
    unobserveOnEnter: false,
    onChange: ({inView}) => {
      if (inView && !hasTriggeredRef.current) {
        if (timerRef.current) {
          clearTimeout(timerRef.current)
        }

        timerRef.current = setTimeout(() => {
          if (inView && !hasTriggeredRef.current) {
            onVisible()
            hasTriggeredRef.current = true
            unobserve()
          }
        }, 1000)
      } else if (!inView && timerRef.current) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
    },
  })

  return (
    <GameLink
      gameCode={gameCode}
      gameName={gameName}
      propertyCode={propertyCode}
      reffererLayout={reffererLayout}
      ref={observe}
      {...restProps}
    >
      {children}
    </GameLink>
  )
}

export default GameLinkWithImpressionTracking
